export default __webpack_public_path__ + "static/VarelaRound-Regular-09bcf238d41dcad55a1074321ec968bd.otf";